<template>
  <div class="main-center">
    <div class="container container-shurt">
      <div class="card-main">
        <div class="header">
          <div class="logo mb-2">
            <Logo
              :src="summary.account_id.logo_media_url"
              max-width="160px" />
          </div>
          <h2 v-if="isTest">Bem-vindo(a) ao<br> Teste</h2>
          <h2 v-if="!isTest">Bem-vindo(a) ao<br> Questionário</h2>
        </div>

        <div
          v-if="isTest"
          class="card my-4">
          <div class="card-header">
            Esse teste consiste em:
          </div>
          <div class="card-body">
            <i class="fas fa-question icon"></i><br>
            <strong>{{ summary.total_questions }} questões</strong>
            <hr>
            <i class="far fa-clock icon"></i><br>
              <strong>{{ summary.time_limit }} minutos</strong> de duração
          </div>
        </div>

        <div
          v-if="!isTest"
          class="card my-4">
          <div class="card-header">
            Esse questionário consiste em:
          </div>
          <div class="card-body">
            <i class="fas fa-question icon"></i><br>
            <strong>{{ summary.total_questions }} questões</strong>
          </div>
        </div>

        <div
          v-if="isTest"
          class="card my-4">
          <div class="card-header">
            Importante
          </div>
          <div class="card-body">
            <p><strong>Não abandone o teste.</strong></p>
            <p>Não feche o navegador ou tente fazer dois testes ao mesmo tempo, isso pode executar um bloqueio de acesso na próxima tentativa.</p>
            <hr>
            <p><strong>Preste atenção no tempo do teste.</strong></p>
            <p>O teste será finalizado automaticamente quando o tempo se esgotar, porém não se preocupe com as questões que você respondeu pois elas serão enviadas antes de finalizar o teste</p>
            <hr>
            <p><strong>Evite interrupções.</strong></p>
            <p>Ao realizar este teste, faça-o em um ambiente tranquilo, calmo, silencioso e evite interrupções.</p>
            <hr>
            <p><strong>Responda todas as questões.</strong></p>
            <p>Você pode navegar livremente entre as questões, porém não esqueça de responder todas elas, uma questão não respondida será considerada como errada.</p>
          </div>
        </div>

        <div class="m-4">
          <div v-if="isTest">
            <label class="mb-3">
              <input type="checkbox" v-model="itsOk">
              <strong> Entendi, desejo começar.</strong>
            </label>
          </div>

          <router-link
            class="btn btn-lg btn-success"
            :class="{disabled: !itsOk}"
            :to="{path: `/${token}/questions`}">
            Iniciar agora
            </router-link>
        </div>
      </div>
      <div class="footer">by <span class="text-muted">Quickin.io</span></div>
    </div>
  </div>
</template>

<script>
import config from '@/config'
import Logo from '../components/Logo'

export default {
  name: 'intro',
  components: {
    Logo
  },
  data () {
    return {
      itsOk: false
    }
  },
  computed: {
    token () {
      return this.$route.params.token
    },
    summary () {
      return this.$store.getters.getSummary
    },
    isTest () {
      return this.summary ? this.summary.type === 'test' : null
    }
  },
  created () {
    this.itsOk = this.summary.type !== 'test'
  },
  methods: {
  }
}
</script>

<style scoped>
  .icon {
    font-size: 2em;
  }
</style>
